import { createAction } from 'redux-actions';
import { ACCOUNT_ACTIVATION_REQUEST } from '../constants/actionTypes';
import * as requestAccountActivation from '../api/account-activation';
import { showSuccessSnackbar, showErrorSnackbar } from './snackbar';

export default function accountActivation(params) {
    return dispatch => requestAccountActivation.accountActivation(params)
        .then((data) => {
            dispatch(showSuccessSnackbar('Password Updated successfully'));
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
                dispatch(showErrorSnackbar('Failed to activate account.'));
            }
        });
}
